import React from "react";
import { Card, CardTitle } from "../ui/Card";
import Dropzone from "../ui/Dropzone";

export default function AttachmentsSection({
  title = "Attachments",
  dropzoneTitle,
  dropzoneHint,
  aside,
  children,
  description,
  accept,
  onFiles,
}) {
  return (
    <Card radius="panel">
      <CardTitle aside={aside}>{title}</CardTitle>

      {description && <p className="rma-nc-attachments-desc">{description}</p>}

      <Dropzone title={dropzoneTitle} hint={dropzoneHint} accept={accept} onFiles={onFiles} />

      {children && <div className="rma-nc-attachments-children">{children}</div>}
    </Card>
  );
}
